import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import VideoStyle from '../../../video/components/VideoStyle';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import PSO from '../../../../services/PSO';
import { toast } from 'react-toastify';
import Strings from '../../../../translations/Translations';

export default function EditStyle(props) {
  const { currentIt } = props;
  const { toggleLoading, authenticated } = useAuth();

  const [style, setStyle] = useState();
  const [currentStyle, setCurrentStyle] = useState();

  const updateStyle = useCallback(async () => {
    if (currentIt && currentIt.rid && style && style.id) {
      if (currentStyle && parseInt(currentStyle) !== parseInt(style.id)) {
        toggleLoading(true);
        try {
          const response = await PSO.replaceOldestExistingElementInRemix({
            un: authenticated.un,
            al: authenticated.al,
            rid: currentIt.rid,
            etype: 4,
            e_sid: style.id
          });
          
          if (response.result === 'success') {
            toast.success(Strings('video_updated'));
            setCurrentStyle(style.id);
          } else {
            const message = (response && response.error) ? response.error : Strings('error_on_request');
            toast.error(message);
          }
        } catch (err) {
          console.error(err);
        }
        toggleLoading(false);
      } else {
        toast.info(Strings('style_already_selected'));
      }
    }
  }, [currentIt, style, toggleLoading, authenticated, currentStyle, setCurrentStyle]);

  const getAllRemixPars = useCallback(async() => {
    toggleLoading(true);
    try {
      const response = await PSO.getRemixPars({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid,
        getappelements: 1
      });

      if (response.result === 'success' && response.getRemixApprovedElements && response.getRemixApprovedElements.its_styles && response.getRemixApprovedElements.its_styles.length > 0) {
        setCurrentStyle(response.getRemixApprovedElements.its_styles[0].estylesid);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        console.error(message);
      }
    } catch (err) {
      console.error(Strings('general_error'));
    }
    toggleLoading(false);
  }, [authenticated, toggleLoading, currentIt, setCurrentStyle]);

  useEffect(() => {
    getAllRemixPars();
  }, [getAllRemixPars]);

  return (
    <Fragment>
      <Row>
        <Col>
          <VideoStyle
            setParentStyle={setStyle}
            parentStyle={style}
            showSaveButton={true}
            saveButtonCallback={updateStyle}
          />
        </Col>
      </Row>
    </Fragment>
  );
}
